import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AppService } from './app.service';

@Injectable()
export class AuthService {
  _isLoggedIn: boolean;
  _sessionTimeout: boolean;
  _alreadyVoted: boolean;

  constructor(
    private appService: AppService,
    private router: Router,
    private http: HttpClient) {
    this._isLoggedIn = false;
    this._sessionTimeout = false;
    this._alreadyVoted = false;
  }

  get isLoggedIn(): boolean {
    return this._isLoggedIn;
  }

  setIsLoggedIn(isLoggedIn:boolean) {
    this._isLoggedIn = isLoggedIn;
  }

  login(loginObj) {
    return this.http
      .post('Home/ngIndex', loginObj)
      .map(
        (response: any) => {
          if (response && response.status === 200) {
            this._isLoggedIn = true;
            return response;
          }
          return response;
        },
        (err) => console.log(err));
  }

  logout() {
    this._isLoggedIn = false;
    return this.http
      .get('Home/LogOut');
  }

  goToLoginPage() {
    this.appService.clearAll();
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/auth.service.ts